import { useNavigate } from "react-router-dom";
import {
  setAddress,
  setOrderType,
  useTypedDispatch,
  useTypedSelector,
} from "../store";
import { useEffect, useRef, useState } from "react";
import { AddressSuggestion, Restaurant } from "../types";

export const useHeaderLogic = () => {
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();

  const [showSideMenu, setShowSideMenu] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const { items, restaurantId } = useTypedSelector((state) => state.cart);
  const { address, orderType } = useTypedSelector(
    (state) => state.session.search
  );

  const cartItemsTotalPrice = items.reduce(
    (acc, item) => acc + item.totalPrice * item.qty,
    0
  );

  const isCartDisabled = !items?.length || !restaurantId || !address;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setShowSideMenu(false);
      }
    };

    if (showSideMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showSideMenu]);

  const handleOnRestaurantSelect = (restaurant: Restaurant) => {
    navigate("/restaurants/" + restaurant._id);
    setShowAddressModal(false);
  };

  const handleOrdertypeSelection = (_field: string, value: string) => {
    dispatch(setOrderType(value));
  };

  const handleAddressSelection = (address: AddressSuggestion) => {
    dispatch(setAddress(address));
  };

  return {
    showSideMenu,
    setShowSideMenu,
    showAddressModal,
    setShowAddressModal,
    menuRef,
    address,
    orderType,
    cartItemsTotalPrice,
    isCartDisabled,
    handleOnRestaurantSelect,
    handleOrdertypeSelection,
    handleAddressSelection,
  };
};
